import styled from 'styled-components';
import { backdropOverlayStyles } from './shared.style';

const Overlay = styled('div')<{ $keyboardInset?: number }>`
  box-sizing: border-box;
  ${backdropOverlayStyles}
  padding: 16px 16px ${({ $keyboardInset }) => ($keyboardInset ?? 0) + 34}px;
  transition: padding-bottom 0.15s ease-out;

  &:has([data-card-dragging='true']) {
    z-index: 110;
  }
`;

export default Overlay;
